import { render, staticRenderFns } from "./NautaMigrationHelpModal.vue?vue&type=template&id=06175784&scoped=true"
import script from "./NautaMigrationHelpModal.vue?vue&type=script&lang=js"
export * from "./NautaMigrationHelpModal.vue?vue&type=script&lang=js"
import style0 from "./NautaMigrationHelpModal.vue?vue&type=style&index=0&id=06175784&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06175784",
  null
  
)

export default component.exports